import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';
import type { DeepLinkingParams } from '../models/deep-linking.model';
import { ResetDeepLinkingParams, SetDeepLinkingParams, SetTFN } from '../store/actions/deep-linking-params.actions';
import { DeepLinkingParamsState } from '../store/deep-linking-params.state';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkingParamsStateService {
  private readonly store = inject(Store);

  // Selectors

  getZip$(): Observable<string> {
    return this.store.select(DeepLinkingParamsState.zip);
  }

  getZip(): string {
    return this.store.selectSnapshot(DeepLinkingParamsState.zip);
  }

  getFips$(): Observable<string> {
    return this.store.select(DeepLinkingParamsState.fips);
  }

  getFips(): string {
    return this.store.selectSnapshot(DeepLinkingParamsState.fips);
  }

  getPlanId$(): Observable<string> {
    return this.store.select(DeepLinkingParamsState.planId);
  }

  getPlanId(): string {
    return this.store.selectSnapshot(DeepLinkingParamsState.planId);
  }

  getPlanType$(): Observable<string> {
    return this.store.select(DeepLinkingParamsState.planType);
  }

  getPlanType(): string {
    return this.store.selectSnapshot(DeepLinkingParamsState.planType);
  }

  getTFN$(): Observable<string> {
    return this.store.select(DeepLinkingParamsState.tfn);
  }

  getTFN(): string {
    return this.store.selectSnapshot(DeepLinkingParamsState.tfn);
  }

  // Actions

  setDeepLinkingParams$(params: DeepLinkingParams): Observable<void> {
    return this.store.dispatch(new SetDeepLinkingParams(params));
  }

  setTFN$(TFN: string): Observable<void> {
    return this.store.dispatch(new SetTFN(TFN));
  }

  resetDeepLinkingParams$(): Observable<void> {
    return this.store.dispatch(new ResetDeepLinkingParams());
  }
}
